// extracted by mini-css-extract-plugin
export var contentBody = "_4x-9";
export var headerImage = "_4x-2";
export var imageButton = "_4x-7";
export var imageButtonIcon = "_4x-8";
export var imageHeader = "_4x-4";
export var imageHeaderText = "_4x-5";
export var imageOverlay = "_4x-3";
export var imageTitle = "_4x-6";
export var imageWrapper = "_4x-1";
export var taskList = "_4x-a";
export var widget = "_4x-0";